import { IPlanProgressCategoryRepresentation } from 'types/common';
import { IPlanProgress } from 'types/dto';
import { categories as categoryViewOptions } from 'utils/categories';

export function usePlanProgressCategoryRepresentation(planProgressList: IPlanProgress[] = []) {
  const categories = planProgressList.reduce((categories, template) => {
    const categoryId = template.type.category.code?.toLowerCase();

    if (categoryId) {
      if (!categories[categoryId]) {
        categories[categoryId] = {
          name: template.type.category.name ?? '',
          ...categoryViewOptions[categoryId],
          templates: [
            {
              template: template.type,
              plan: template.plan,
            },
          ],
        };
      } else {
        categories[categoryId].templates.push({
          template: template.type,
          plan: template.plan,
        });
      }
    }
    return categories;
  }, {} as Record<string, IPlanProgressCategoryRepresentation>);

  return categories;
}
